// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__20t56","ImageBox":"style_ImageBox__Ahurm","Image":"style_Image__1v49I"};